import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgNavMcp = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="M12.524 14.915c-1.332 1.256-3.47 1.313-4.796.02-1.332-1.297-1.254-3.373.06-4.654l4.76-4.638a.9.9 0 0 1 1.25 0 .845.845 0 0 1 0 1.217l-4.76 4.638c-.668.65-.659 1.636-.06 2.221.603.588 1.633.604 2.315-.037l4.753-4.63a.9.9 0 0 1 1.249 0 .845.845 0 0 1 0 1.216L12.53 14.91l-.005.005h-.001Zm6.517-2.946c1.302-1.268 1.266-3.326-.034-4.592a3.425 3.425 0 0 0-2.508-.961 3.238 3.238 0 0 0-.989-2.446c-1.295-1.262-3.388-1.314-4.71-.029l-6.543 6.376a.842.842 0 0 0 0 1.212.897.897 0 0 0 1.245 0l6.543-6.375c.607-.59 1.587-.589 2.22.029.634.618.637 1.57.03 2.163l-4.762 4.64a.842.842 0 0 0 0 1.211.897.897 0 0 0 1.245 0l4.761-4.64c.593-.577 1.591-.584 2.225.034.634.618.626 1.59.034 2.167l-5.008 4.88a2.931 2.931 0 0 0 0 4.222l.914.89a.897.897 0 0 0 1.245 0 .842.842 0 0 0 0-1.213l-.914-.89a1.25 1.25 0 0 1 0-1.798l5.008-4.879-.002-.001Z"
    />
  </svg>
);
export default SvgNavMcp;
